<script>
import appConfig from "@/app.config";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import CreateOrUpdateRole from '@/components/system/role/CreateOrUpdateRole';

/**
 * Form wizard component
 */
export default {
  page: {
    title: "Editar Rol",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Layout,
    PageHeader,
    CreateOrUpdateRole
  },
  data() {
    return {
      title: "Editar Rol",
      items: [
        {
          text: "Roles",
          to: {name: "system.roles"}
        },
        {
          text: "Editar",
          active: true,
        },
      ],
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <create-or-update-role></create-or-update-role>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>



